import { createAction, props } from '@ngrx/store';
import { SubscriptionsModel } from 'src/models/module-wise/subscription/SubscriptionsModel';

export const paginateSubscriptions = createAction(
  '[ SUBSCRIPTION ] Paginating'
);

export const loadSubscriptions = createAction(
  '[ SUBSCRIPTIONS ] Load Subscriptions',
  props<SubscriptionsModel>()
);

export const loadSubscriptionDetails = createAction(
  '[ SUBSCRIPTIONS ] Get Subscription Details',
  props<{ _id: string }>()
);
